import React from "react";

const ApplicationContext = React.createContext({
  productDetails: null,
});

export default ApplicationContext;
